import { useContext } from "react";
import { UseQueryOptions } from "react-query";
import { CvPortalJobFull } from "../../api/jobs/getJobFull";
import { getCallingCode } from "../../WSUtils/getIdLanguage";
import { useLatestQuery } from "../../WSUtils/useLatestQuery";
import { UserInfoContext } from "../../WSUtils/UserInfoContext";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../WSUtils/wsQueryStringStore";

export interface UseCvPortalJobFullProps {
  idRelated: number;
  typeRelated: number;
}

export const useCvPortalJobFull = (
  { idRelated, typeRelated }: UseCvPortalJobFullProps,
  options?: UseQueryOptions<CvPortalJobFull, unknown, CvPortalJobFull>
) => {
  const userInfo = useContext(UserInfoContext);

  return useLatestQuery(
    [
      "getJobFull",
      idRelated,
      typeRelated,
      userInfo.idConcern,
      getCallingCode(userInfo.locale),
      queryStringStore.qs[CVPSearchParams.cvpssid],
      queryStringStore.qs[CVPSearchParams.cvpttid],
    ],
    () =>
      userInfo.fullAPI.jobsAPI.getJobFull({
        userInfo,
        idRelated,
        typeRelated,
        konsernid: userInfo.idConcern,
        languageId: getCallingCode(userInfo.locale),
        sesjonsId: queryStringStore.qs[CVPSearchParams.cvpssid] as string,
        terminalId: queryStringStore.qs[CVPSearchParams.cvpttid] as string,
        consultantMode:
          !!queryStringStore.qs[CVPSearchParams.cvpttid] &&
          !!queryStringStore.qs[CVPSearchParams.cvpssid],
      }),
    options
  );
};
